import { createSlice } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import { EventPostType } from 'Utils/events/types';
export const initialState = {
    editedEventForm: null,
    editedEventFormLeaveMessage: {
        isOpen: false,
        text: '',
        action: () => { }
    },
    editedEventFormRestoreMessage: {
        isOpen: false,
        text: '',
        action: () => { }
    },
    storedEventUpdateHash: {},
    storedEventCreateHash: {},
    editedEventFormRestorePermission: null
};
export const monitoringEventFormSlice = createSlice({
    name: 'monitoringEventForm',
    initialState,
    reducers: {
        setMonitoringEditedEventForm: (state, action) => {
            state.editedEventForm = action.payload;
        },
        bumpVersionMonitoringEditedEventForm: (state, action) => {
            state.editedEventForm = {
                ...state.editedEventForm,
                eventVersion: action.payload
            };
        },
        clearMonitoringEditedEventForm: (state) => {
            state.editedEventForm = null;
        },
        saveMonitoringEditedEventForm: (state) => {
            const { type } = state.editedEventForm || { type: null };
            switch (type) {
                case EventPostType.CREATE: {
                    const { modelName } = state.editedEventForm;
                    state.storedEventCreateHash = {
                        ...state.storedEventCreateHash,
                        [modelName]: state.editedEventForm
                    };
                    break;
                }
                case EventPostType.UPDATE: {
                    const { eventId } = state.editedEventForm;
                    state.storedEventUpdateHash = {
                        ...state.storedEventUpdateHash,
                        [eventId]: state.editedEventForm
                    };
                    break;
                }
                default:
            }
            state.editedEventForm = null;
        },
        deleteMonitoringEditedEventFormStored: (state, action) => {
            const { type, storeKey } = action.payload || { type: null };
            switch (type) {
                case EventPostType.CREATE: {
                    const nextStored = omit(state.storedEventCreateHash, storeKey);
                    state.storedEventCreateHash = nextStored;
                    break;
                }
                case EventPostType.UPDATE: {
                    const nextStored = omit(state.storedEventUpdateHash, storeKey);
                    state.storedEventUpdateHash = nextStored;
                    break;
                }
                default:
            }
        },
        setMonitoringEditedEventFormRestorePermission: (state, action) => {
            state.editedEventFormRestorePermission = action.payload;
        },
        clearMonitoringEditedEventFormRestorePermission: (state) => {
            state.editedEventFormRestorePermission = null;
        },
        setMonitoringEditedEventFormLeaveMessage: (state, action) => {
            const { isOpen } = state.editedEventFormLeaveMessage;
            if (!isOpen)
                state.editedEventFormLeaveMessage = action.payload;
        },
        clearMonitoringEditedEventFormLeaveMessage: (state) => {
            state.editedEventFormLeaveMessage = initialState.editedEventFormLeaveMessage;
        },
        setMonitoringEditedEventFormRestoreMessage: (state, action) => {
            state.editedEventFormRestoreMessage = action.payload;
        },
        clearMonitoringEditedEventFormRestoreMessage: (state) => {
            state.editedEventFormRestoreMessage = initialState.editedEventFormRestoreMessage;
        }
    }
});
export const { setMonitoringEditedEventForm, bumpVersionMonitoringEditedEventForm, clearMonitoringEditedEventForm, saveMonitoringEditedEventForm, deleteMonitoringEditedEventFormStored, setMonitoringEditedEventFormRestorePermission, clearMonitoringEditedEventFormRestorePermission, setMonitoringEditedEventFormLeaveMessage, clearMonitoringEditedEventFormLeaveMessage, setMonitoringEditedEventFormRestoreMessage, clearMonitoringEditedEventFormRestoreMessage } = monitoringEventFormSlice.actions;
export default monitoringEventFormSlice.reducer;
